export const FRONT_SIZE_NORMAL = '16px'
export const FONT_SIZE_X = '20px'